import './notification_settings.less'
import React, {PropTypes} from 'react';
import {Link, browserHistory} from 'react-router';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MediaQuery from 'react-responsive';
import SuccessMessage from '../../components/success/success_msg';
import Checkbox from '../../components/checkbox/checkbox';
import DashBoardHeader from '../../header_dashboard/dashboard_header';
import ProfileNavBar from '.././profile_navbar/profile_navbar';
import validate from '../../util/validate';
import {toTitleCase, join} from '../../util/common';
import ShowError from '../../components/error/show_error';
import authActions from '../../auth/auth_actions';
import profileActions from '../../profile/profile_actions';
import LogoutPopUp from '../../components/logoutPopUp/logout_pop_up';
import LoggedinFooter from '../../footer/loggedin_footer';
import CONSTANTS from '../../common_constants';

class NotificationSettingsDetails extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      offerStatus: false,
      newMessages: false,
      locationStatus: false,
      newPackagesAvailable:false,
      isEmail:false,
      isSms : false,
      isPush : false
    }
  }

  handleChange = (checked , name) =>{
    const {userData} = this.props.authState;

    this.setState({
      [name] : checked
    }, function () {
      this.setState({
        ajaxInProgress : true
      })
      let paramObj = Object.assign({} , this.state);
      delete paramObj['ajaxInProgress'];

      if(paramObj.isSms){
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.USER_ENABLE_SMS_NOTIFICATION);
      }

      this.props.profileActions.setAllNotificationSettings(paramObj).then((data)=>{
        this.setState({
          ajaxInProgress : false
        })
      },(errorRes)=>{
        if(errorRes.error === CONSTANTS.sessionInvalid){
              this.setState({ajaxInProgress: false})
              this.props.authActions.sessionValid(false);
              cookies.delete('_sd');
              return ;
            }
        this.setState({
          ajaxInProgress : false
        })
      })
    })
  }
  componentDidMount(){
    this.setState({
      ajaxInProgress : true
    })
    this.props.profileActions.getAllNotificationsSettings().then((data)=>{
      this.setState({
        offerStatus: data.offerStatus,
        newMessages: data.newMessages,
        locationStatus: data.locationStatus,
        newPackagesAvailable:data.newPackagesAvailable,
        isEmail:data.isEmail,
        isSms : data.isSms,
        ajaxInProgress :false,
        isPush : data.isPush
      })
    },(errorRes)=>{
        console.log(errorRes,"error here");
        console.log("constant" ,CONSTANTS.sessionInvalid);
      if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({ajaxInProgress: false})
            this.props.authActions.sessionValid(false);
            cookies.delete('_sd');
            return ;
          }
      this.setState({
        ajaxInProgress : false
      })
    })
  }
  render() {
    return (
      <div className="notification-setings-details-wrap">
        {this.state.ajaxInProgress && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        <div className ="heading">
          Notifications
        </div>
        <div className="event-heading">
          Notifications events
        </div>
        <div className="notifications-events">
          <div className="event-name">
            Offer status
          </div>
          <div className="setting">
            <Checkbox status ={this.state.offerStatus} handleChange = {this.handleChange} id = "offerStatus"/>
          </div>
        </div>
        <div className="border-div">
        </div>
        <div className="notifications-events">
          <div className="event-name">
            New messages
          </div>
          <div className="setting">
            <Checkbox status ={this.state.newMessages} handleChange = {this.handleChange} id = "newMessages"/>
          </div>
        </div>
        <div className="border-div">
        </div>
        <div className="notifications-events">
          <div className="event-name">
            Location status
          </div>
          <div className="setting">
            <Checkbox status ={this.state.locationStatus} handleChange = {this.handleChange} id = "locationStatus"/>
          </div>
        </div>
        <div className="border-div">
        </div>
        <div className="notifications-events">
          <div className="event-name">
            New packages available
          </div>
          <div className="setting">
            <Checkbox status ={this.state.newPackagesAvailable} handleChange = {this.handleChange} id = "newPackagesAvailable"/>
          </div>
        </div>
        <div className="border-div">
        </div>
        <div className="event-heading">
          Notifications type
        </div>
        <div className="notifications-events">
          <div className="event-name">
            Email
          </div>
          <div className="setting">
            <Checkbox status ={this.state.isEmail} handleChange = {this.handleChange} id = "isEmail"/>
          </div>
        </div>
        <div className="notifications-events">
          <div className="event-name">
            SMS
          </div>
          <div className="setting">
            <Checkbox status ={this.state.isSms} handleChange = {this.handleChange} id = "isSms"/>
          </div>
        </div>
      </div>
    )
  }
}

class NotificationSettings extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {props, state} = this;
    const {userData} = props.authState;
    let sessionValid = true ;
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid
   let user = {
      name: '',
      imageUrl: '',
      isVerified: '',
      creditAmount: ''
    };

    if(props.authState) {
      user.name = userData.name;
      user.imageUrl = userData.profileImageUrl;
      user.isVerified = userData.isVerified;
      user.creditAmount = userData.creditAmount
    }
    return (
      <div className="account-details-wrap account-section">
        <DashBoardHeader user={user} logout={this.logout}/>
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <div className="account-header-wrap">
          <div className="wrapper">
            <h2 className="page-header account-page-header">Account</h2>
          </div>
        </div>
        <div className="wrapper account-wrapper">
          <div className="profile-nav-bar-component">
            <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
            </div>
            <div className="account-details-component">
              <NotificationSettingsDetails
                authActions = {this.props.authActions}
                profileActions = {this.props.profileActions}
                authState = {this.props.authState}
              />
            </div>
          </div>
          <LoggedinFooter />
      </div>
    )
  }
}

NotificationSettings = connect((state) => {
    return {
      authState: state.app.auth,
      profile: state.app.profile
    }
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        profileActions: bindActionCreators(profileActions, dispatch)
    }
})(NotificationSettings);

export default NotificationSettings;



// WEBPACK FOOTER //
// app/profile/notification_settings/notification_settings.jsx